import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../../services/dashboard.service';
import { FormControl } from '@angular/forms';
import { BloccoAuthModel } from '../../../../models/dashboard/BloccoAuth.model';

@Component({
  selector: 'app-ruolo-blocco-manager',
  templateUrl: './ruolo-blocco-manager.component.html',
  styleUrls: ['./ruolo-blocco-manager.component.css']
})
export class RuoloBloccoManagerComponent implements OnInit {

  checkboxRuoli: Array<{
    id: number,
    name: string,
    checked: boolean
  }> = [];

  idBlocco: number;
  ruolo: FormControl = new FormControl('');

  authManItems: Array<{
    id: any,
    idAuthManItems: any
  }> = [];

  constructor(
    private _dashboardService: DashboardService
  ) { }

  ngOnInit() { }

  createArrayForView(authManItems?: Array<any>) {
    this._dashboardService.getAuthManItems().subscribe(
      ruoli => {
        this.createAuthManItemsArray(authManItems);

        for (const ruolo of ruoli) {
          const newRuolo = {
            id: ruolo.id,
            name: ruolo.name,
            checked: this.checkForAuthManItems(ruolo.id, authManItems ? authManItems : null)
          };
          this.checkboxRuoli.push(newRuolo);
        }
      }, err => { });
  }

  createAuthManItemsArray(authManItems) {
    if (authManItems) {
      for (let item of authManItems) {
        const itemToPush = {
          id: item.id,
          idAuthManItems: item.idAuthManItems
        };
        this.authManItems.push(itemToPush);
      }
    }
  }

  checkForAuthManItems(idRuolo: number, authManItems?: Array<any>): boolean {
    if (authManItems) {
      return authManItems.find(item => item.idAuthManItems === idRuolo) ? true : false;
    } else {
      return false;
    }
  }

  setChecked(idRuolo: number, value: boolean) {
    const index = this.checkboxRuoli.findIndex(item => item.id === idRuolo);
    this.checkboxRuoli[index].checked = value;
  }

  getRuolo = () => this.ruolo.value;
  setRuolo = (ruolo: Array<string>) => this.ruolo.setValue(ruolo);

  change(option, event) {

    const bloccoToAuth: BloccoAuthModel = {
      dataInizio: new Date().toISOString(),
      idAuthManItems: option.id,
      idBlocco: this.idBlocco
    }

    if (event.checked) {
      this._dashboardService.addBloccoToAuth(bloccoToAuth).subscribe(
        res => {
          this.setChecked(bloccoToAuth.idAuthManItems, true);
          this.addAuthManItem(res);
        },
        err => { });
    } else {
      const id = this.getIdAuthManItemsByIdRuolo(bloccoToAuth.idAuthManItems);
      this._dashboardService.deleteBloccoAuth(id).subscribe(
        res => {
          this.setChecked(bloccoToAuth.idAuthManItems, false);
          this.removeAuthManItem(res);
        },
        err => { });
    }
  }

  getIdAuthManItemsByIdRuolo(idRuolo): number {
    const findedItem = this.authManItems.find(item => item.idAuthManItems === idRuolo).id;
    return findedItem;
  }

  addAuthManItem(res) {
    this.authManItems = [...this.authManItems, { id: res.id, idAuthManItems: res.idAuthManItems }];
  }

  removeAuthManItem(res) {
    const index = this.authManItems.findIndex(item => item.id === res.id);
    this.authManItems.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-manager/ruolo-blocco-manager/ruolo-blocco-manager.component.ts